/**
 * Registry → AI models tab. Admin UI for the AI gateway's model registry.
 */

import type { ReactElement } from 'react';
import { AiModelsPanel } from '@features/aiModels/components/AiModelsPanel';

export function AiModelsTab(): ReactElement {
  return <AiModelsPanel />;
}
